// src/types/service.ts

//export type ServiceType = 'lawyer' | 'trainee' | 'subscriber';
export enum ServiceType {
  LAWYER = "lawyer",
  TRAINEE = "trainee",
  SUBSCRIBER = "subscriber"
}
export interface Service {
  id: number;
  name: string;
  type: ServiceType;
  description: string;
  fee: number;
}


